import React from 'react';

const Footer = () => {
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/e80eb4a41c317bb5346a84936eb4292e.png";

  return (
    <footer className="bg-retro-brown text-retro-cream py-16 border-t-4 border-retro-yellow">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center md:items-start gap-12">
        
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <div className="mb-6 bg-white p-4 rounded-2xl border-4 border-retro-yellow transform -rotate-2">
            <img 
              src={logoUrl} 
              alt="Mailbox Flyers" 
              className="h-20 w-auto object-contain"
            />
          </div>
          <div className="mt-2 px-4 py-1 border-2 border-retro-cream rounded-full inline-block font-display uppercase tracking-widest text-[10px]">
            The Targeted Direct Mail Experts
          </div>
        </div>

        <div className="font-body text-center md:text-right font-bold space-y-2 text-lg">
          <p className="text-retro-yellow">Connect with Local Customers</p>
          <p>123 Flyer Way, Suite 100</p>
          <p>Anytown, ST 12345</p>
          <a href="tel:5551234567" className="block hover:text-retro-yellow transition-colors mt-4 font-display text-2xl tracking-tighter">(555) 123-4567</a>
          <a href="mailto:hello@mailboxflyers.com" className="block hover:text-retro-yellow transition-colors">hello@mailboxflyers.com</a>
        </div>

      </div>
      
      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-retro-cream/10 text-center md:text-left">
        <p className="font-body text-sm opacity-60">© {new Date().getFullYear()} Mailbox Flyers. All rights reserved. One category per card. Targeted excellence.</p>
      </div>
    </footer>
  );
};

export default Footer;